const utils = {};

utils.getXItemsFromString = function (data, separator, quantity) {
	const brandsArray = data.split(separator);
	const selectedBrands = brandsArray.slice(0, quantity);
	return {
		'selected':selectedBrands,
		'total':brandsArray.length,
	};
};

utils.productTitleEvent = function (info, cat, page = ''){
	let cat_from_eitem = (info).find('.catalog-product-oem-category a')[0];
	cat_from_eitem = cat_from_eitem ? cat_from_eitem.innerText.split(' - ')[1].trim() : '';
	let pob = (info).find('.place-order-button');
	cat = cat ? cat.innerText.trim() : ''; 
	let category = utils.getStringFromTwoStrings(cat_from_eitem, cat);
	let sale_price = pob.attr('data-sale-price'); 
	let stock = pob.attr('data-in-stock')? 'In Stock':'No Stock' ;

	const product = {
		sku_stripped: pob.attr('data-sku-stripped'),
		name: pob.attr('data-name'),
		brand: pob.attr('data-brand'),
		category: category,
		price: sale_price,
		quantity: pob.attr('data-quantity'),
		page: page || 'Unavailable',
		stock_status: stock,
	};

	return product;
};

utils.getItemsFromRpappCart = function (items){
	return items.map(item => {
		item = (item.product.product_data);
		return {
			id: item.sku_stripped,
			name: item.name,
			quantity: item.quantity,
			brand: item.brand,
			price: item.total_sale_price,
		};
	});
};

utils.getStringFromTwoStrings = function (str1, str2, default_value = null) {
	return str1.trim() || str2.trim() || default_value;
};


utils.convertNamesOfItemsForGA = function (items) {
	return items.map((item, index) => ({
		item_id: item.id || item.sku_stripped,
		item_name: item.name,
		item_brand: item.brand,
		item_category: item.category || 'Unavailable',
		price: item.price,
		quantity: item.quantityDifference || (item.quantity || 1),
		item_list_name: item.page || 'Unavailable',
		index: index + 1,
	})); 
};

utils.updateQuantityForGA = function (items) {
	return items.map((item, index) => ({
		item_id: item.id,
		item_name: item.name,
		item_brand: item.brand,
		item_category: 'Unavailable',
		price: item.price,
		quantity: Math.abs(item.quantity - item.initialQuantity),
		item_list_name: 'Unavailable',
		index: index + 1
	})); 
};

utils.hashSensitiveInformation =  function (value) {
	return new Promise(function (resolve, reject) {
		if (!value) return resolve('');
		const encoder = new TextEncoder();
		const data = encoder.encode(value);
		crypto.subtle.digest('SHA-256', data)
			.then(function (hashBuffer) {
				const hashArray = Array.from(new Uint8Array(hashBuffer));
				const hashHex = hashArray.map(function (b) {
					return b.toString(16).padStart(2, '0');
				}).join('');
				resolve(hashHex);
			})
			.catch(function (error) {
				reject(error);
			});
	});
};

utils.buildCarString = function (carDetails) {
	const year = carDetails.ui_year || '';
	const make = carDetails.ui_make || '';
	const model = carDetails.ui_model || '';

	if (!year && !make && !model) {
		return 'NotSelected';
	}
	return `${year} ${make} ${model}`.trim(); 
};

utils.getNonEmptyString = function (value) {
	return (typeof value === 'string' && value !== '') ? value : null;
};

utils.getNumberString = function (value) {
	if (typeof value === 'number' && Number.isFinite(value) && value !== 0) return String(value);
	if (typeof value === 'string' && value !== '') return value;
	return null;
};

utils.buildVehicleBasePath = function (carDetails) {
	if (!carDetails || typeof carDetails !== 'object') {
		return null;
	}

	const year = utils.getNumberString(carDetails.year) ?? utils.getNumberString(carDetails.ui_year);
	const make = utils.getNonEmptyString(carDetails.make) ?? utils.getNonEmptyString(carDetails.ui_make);
	const model = utils.getNonEmptyString(carDetails.model) ?? utils.getNonEmptyString(carDetails.ui_model);
	const trim = utils.getNonEmptyString(carDetails.trim) ?? utils.getNonEmptyString(carDetails.ui_trim);
	const engine = utils.getNonEmptyString(carDetails.engine) ?? utils.getNonEmptyString(carDetails.ui_engine);

	if (!year || !make || !model) {
		return null;
	}

	const seg = (v) => encodeURIComponent(v);
	let path = `/v-${seg(year)}-${seg(make)}-${seg(model)}`;
	if (trim) {
		path += `--${seg(trim)}`;
	}
	if (engine) {
		path += `--${seg(engine)}`;
	}
	return path;
};

/**
 * Sets `href` on `a.js-vpicker-select-vehicle` from `.vehiclepicker_wrapper` data-* (YMM + optional suffix).
 *
 * @param {HTMLAnchorElement|null|undefined} anchor
 * @returns {boolean} Whether `href` was updated
 */
utils.applyWrapperHref = function (anchor) {
	if (!anchor || typeof anchor.closest !== 'function') {
		return false;
	}
	const current = anchor.getAttribute('href');
	const needsHydrate = current === null || current === '' || current.trim().toLowerCase().startsWith('javascript:');
	if (!needsHydrate) {
		return false;
	}
	const wrapper = anchor.closest('.vehiclepicker_wrapper');
	if (!wrapper?.dataset) {
		return false;
	}
	const ds = wrapper.dataset;
	const year = utils.getNumberString(ds.year ?? null);
	const make = utils.getNonEmptyString(ds.make ?? null);
	const model = utils.getNonEmptyString(ds.model ?? null);
	if (!year || !make || !model) {
		return false;
	}
	const trim = utils.getNonEmptyString(ds.trim ?? null);
	const engine = utils.getNonEmptyString(ds.engine ?? null);
	const carDetails = {
		year,
		ui_year: year,
		make,
		ui_make: make,
		model,
		ui_model: model,
		trim: trim ?? '',
		ui_trim: trim ?? '',
		engine: engine ?? '',
		ui_engine: engine ?? '',
	};
	const path = utils.buildVehicleBasePath(carDetails);
	if (!path) {
		return false;
	}
	const suffix = typeof ds.browseSuffix === 'string' ? ds.browseSuffix : '';
	anchor.setAttribute('href', path + suffix);
	return true;
};

utils.getCookie = function (name) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(';').shift(); 
	else return '{}';
};

utils.setCookie = function (name, value, days) {
	var expires = '';
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 *1000));
		expires = '; expires=' + date.toGMTString();
	} else {
		expires = '';
	}
	document.cookie = name + '=' + value + expires + '; path=/';
};

utils.deleteCookie = function (name) {
	utils.setCookie(name,'',-1);
};

utils.isTruthyDataValue = function (value) {
	if (value === true || value === 1) {
		return true;
	}
	if (value === false || value === 0 || value === null || value === undefined) {
		return false;
	}
	if (typeof value === 'string') {
		const normalized = value.trim().toLowerCase();
		return normalized === 'true' || normalized === '1';
	}
	return false;
};

utils.normalizeEventPayloadArgs = function (eventOrPayload, maybePayload, rest = []) {
	if (!Array.isArray(rest)) {
		rest = [rest];
	}
	if (Array.isArray(eventOrPayload)) {
		return eventOrPayload;
	}
	if (Array.isArray(maybePayload)) {
		return maybePayload;
	}
	if (rest.length) {
		return (maybePayload && typeof maybePayload === 'object') ? [maybePayload].concat(rest) : rest;
	}
	if (maybePayload && typeof maybePayload === 'object') {
		return [maybePayload];
	}
	return [];
};

utils.canProceedCheckoutWithQuantityLimitEnabled = function () {
	if (!rp_app?.cart?._can_apply_cart_quantity_limit) {
		return Promise.resolve();
	}

	rp$('body').overlaySpinner();
	rp$('.spinner-overlay').css('position', 'fixed');
	rp$('.spinner-icon').css('position', 'fixed');

	return new Promise((resolve, reject) => {
		$ajax({
			type: 'GET',
			url: '/ajax/cart',
			dataType: 'json',
			data: {
				displayBrandDisclosure: rp_app?.cart?.displayBrandDisclosure ?? false,
			},
			contentType: 'application/json',
			success: (response) => {
				rp$('body').overlaySpinner.remove();

				let renderedItemsCount = null;
				const $cartListing = rp$('.cart-listing[data-can-apply-cart-quantity-limit]');
				if ($cartListing.length > 0) {
					const dataCount = $cartListing.attr('data-cart-items-count');
					if (dataCount !== undefined && dataCount !== null && dataCount !== '') {
						renderedItemsCount = parseInt(dataCount, 10);
					}
				}

				if (renderedItemsCount === null || isNaN(renderedItemsCount)) {
					renderedItemsCount = rp_app?.cart?.item_count || 0;
				}

				if (renderedItemsCount !== response.itemsCount) {
					rp$('#can-proceed-checkout-quantity-limit-enabled').modal();
					
					setTimeout(function() {
						rp_app.location.redirect('/cart');
					}, 100);
					reject(new Error('Quantity mismatch between request data and cart items.'));
				} else {
					resolve();
				}
			},
			error: () => {
				rp$('body').overlaySpinner.remove();
				reject(new Error('Failed to validate cart quantity limit'));
			}
		});
	});
};

/**
 * Checks if the current user agent is a bot
 */
utils.isBot = function () {
	const checks = [
		// NOTE: Be careful with using simple terms like "Claude" as it's possible Anthropic could release a browser 
		// with that name in the future and this could result in blocking legitimate users

		// search bots
		/Googlebot|Bingbot|BingPreview|MicrosoftPreview|BingVideoPreview|Baiduspider|YandexBot|Applebot|DuckDuckBot/i,
		// ai bots
		/Claude-Web|Claude-SearchBot|ClaudeBot|Claude-User|PerplexityBot|ChatGPT|OAI-SearchBot|GPTBot|Meta-ExternalAgent|FacebookBot|Meta-ExternalFetcher|Redditbot|Amazonbot|AmazonBuyForMe|GoogleAgent|TwinAgent|Amzn-User|DuckAssistBot/i,
		// misc other bots
		/SemrushBot|AhrefsBot|DataForSeoBot|GoogleOther|GoogleSearchConsole|Storebot-Google|Google-Extended|AdsBot/i,
	];

	return checks.some(check => check.test(navigator.userAgent));
};

module.exports = utils;
